import React, { useState } from 'react';
import { Row, Col, Card, Button, Badge, Modal, List, Typography, Space } from 'antd';
import { BellOutlined, SwapOutlined, CheckCircleOutlined, DatabaseOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const InventoryDashboard = () => {
  const [notifications, setNotifications] = useState([
    { id: 1, message: 'New spare part request from Sales Dept.' },
    { id: 2, message: 'Spare part transfer pending approval.' },
  ]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showNotifications = () => setIsModalVisible(true);
  const handleOk = () => setIsModalVisible(false);

  const quickActions = [
    {
      title: 'Transfer Spare Part',
      description: 'Send spare parts to another warehouse',
      icon: <SwapOutlined style={{ fontSize: 24 }} />,
      link: '/inventory/transfer',
      type: 'primary',
    },
    {
      title: 'Accept Spare Part',
      description: 'Accept incoming spare parts',
      icon: <CheckCircleOutlined style={{ fontSize: 24 }} />,
      link: '/inventory/accept',
      type: 'default',
    },
    {
      title: 'Notifications',
      description: 'View all notifications',
      icon: <BellOutlined style={{ fontSize: 24 }} />,
      onClick: showNotifications,
      badge: notifications.length,
      type: 'dashed',
    },
  ];

  const stats = [
    { title: 'Total Spare Parts', value: 1280, icon: <DatabaseOutlined style={{ fontSize: 28 }} /> },
    { title: 'Pending Transfers', value: 15, icon: <SwapOutlined style={{ fontSize: 28 }} /> },
    { title: 'Pending Acceptance', value: 8, icon: <CheckCircleOutlined style={{ fontSize: 28 }} /> },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Inventory Dashboard</Title>

      {/* Quick Action Buttons */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24, justifyContent: 'flex-end' }}>
        {quickActions.map((action, idx) => (
          <Col key={idx}>
            <Badge count={action.badge} offset={[10, 0]}>
              <Button
                type={action.type}
                size="large"
                style={{
                  width: 220,
                  height: 80,
                   
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 12,
                  boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                  fontWeight: 'bold',
                }}
                onClick={action.onClick}
                href={action.link}
              >
                {action.icon}
                <span>{action.title}</span>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {action.description}
                </Text>
              </Button>
            </Badge>
          </Col>
        ))}
      </Row>

      {/* Stats Cards */}
      <Row gutter={[16, 16]}>
        {stats.map((stat, idx) => (
          <Col xs={24} sm={12} md={8} key={idx}>
            <Card hoverable style={{ borderRadius: 12, boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
              <Space direction="horizontal" size="large">
                {stat.icon}
                <div>
                  <Text strong style={{ fontSize: 18 }}>{stat.value}</Text>
                  <br />
                  <Text type="secondary">{stat.title}</Text>
                </div>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Notification Modal */}
      <Modal
        title="Notifications"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleOk}
        okText="Close"
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <List
          dataSource={notifications}
          renderItem={(item) => <List.Item key={item.id}>{item.message}</List.Item>}
        />
      </Modal>
    </div>
  );
};

export default InventoryDashboard;
